import { defineStore } from "pinia";
 

export const useShareMetaStore = defineStore("shareMeta", () => {
  const title = ref("");
  const description = ref("");
  const url = ref("");
  const image = ref("");

  const hasUrl = computed(() => !!url.value);

  const setMeta = (payload = {}) => {
    const { title: t, description: d, url: u, image: i } = payload;

    if (t !== undefined) title.value = t ?? "";
    if (d !== undefined) description.value = d ?? "";
    if (u !== undefined) url.value = u ?? "";
    if (i !== undefined) image.value = i ?? "";
  };

  const clear = () => {
    title.value = "";
    description.value = "";
    url.value = "";
    image.value = "";
  };

  return {
    title,
    description,
    url,
    image,
    hasUrl,
    setMeta,
    clear,
  };
});
